// extracted by mini-css-extract-plugin
export default {"cls1":"AuthorHeader-cls1__ccbbca723ac02a6e514f","cls2":"AuthorHeader-cls2___2d0a616fc24d7eec481 AuthorHeader-cls1__ccbbca723ac02a6e514f"};